const SiteIds = {
    0: "דפי זהב",
    1: "רסט",
    3: "משלוחים",
    4: "מתחתנים",
    7: "דוקטורס",
    8: "משפטי",
    10:"חוגל",
    11: "חוג"
};


export default Object.freeze(SiteIds);